import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentTopBar } from 'components';
import { AddSponserModal } from 'features/sponsers/component/modal/add-sponser-modal';
import { useState } from 'react';
import { CompanyType } from 'types';
const { useBreakpoint } = Grid;

export const SponserTopBar = ({ initialValues, handleFilter, form }: any) => {
  useState<CompanyType>();
  const screens = useBreakpoint();

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ContentTopBar
        title={'Sponsor'}
        renderButtons={
          <>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => {
                setShowModal(true);
                document.body.style.overflow = 'hidden';
              }}
            >
              Add Sponsor
            </Button>
            {showModal && (
              <AddSponserModal
                onClose={() => setShowModal(false)}
                initialValues={initialValues}
                handleFilter={handleFilter}
                filterForm={form}
              />
            )}
          </>
        }
      />
    </>
  );
};
